<template>
  <BjDialog :visible="visible" width="500px">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item :label="$t('InternalOrder.form.AbnormalCause')" prop="failReason">
        <BjInput
          v-model="form.failReason"
          type="textarea"
          :maxlength="MAX_LENGTH.REMARK"
          show-word-limit
          resize="none"
          size="medium"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="hide">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
    </template>
  </BjDialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        failReason: null,
      },
    };
  },
  methods: {
    show() {
      this.form.failReason = null;
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    confirm() {
      this.$emit('comfirm', this.form.failReason);
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped></style>
